/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Spin, Typography, Popover, List, Tooltip, Select, Button, notification, Switch, Badge, message, Modal, Input, Tag } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import {
    CopyOutlined,
    MoreOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    LoadingOutlined,
    CheckCircleTwoTone,
    CheckOutlined,
    CloseOutlined,
    WarningTwoTone,
    WarningOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    FieldTimeOutlined,
    ControlOutlined,
} from '@ant-design/icons';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import ManageCsv from '../../components/ManageCsv/ManageCsv';
import OrderCard from '../../components/OrderCard/OrderCard';
import { fetchAllCSvOrders, fetchAllCSvOutboundOrders } from '../../hooks/useCsvOrder';
import useLogout from '../../hooks/useLogout';
import {
    fetchAllOrders,
    piRequestReject,
    piRequestSuccess,
    useDownloadPII,
    fetchNotificationsForOrder,
    useDownloadCC,
    useGenerateInboundReport,
    useMarkOrderCSA,
    useSyncDataToAIStyling
} from '../../hooks/useOrders';
import CommonTable from '../../commonComponents/Table/table';
import PlusIconActionButton from '../../components/PlusIconActionButton';
import { downloadSku, useDownloadOutboundReport, useIgnoreforCC } from '../../hooks/useSkuModal';
import { useListingCompanies } from '../../hooks/useCompanies';
import stc from 'string-to-color';
import PiRequestStatus from '../../components/PiRequestStatus/PiRequestStatus';
import DownloadPiiModal from '../../components/DownloadPiiModal';
import NotificationModal from '../../pages/notifications';
import StyleColorLibraryModal from '../../components/StyleColorLibraryModal';
import { RetainmentContext } from '../../context/retainmentContext';
import './orderStyle.scss';
const { Text, Link } = Typography;

const AllOrders = () => {
    const { logout } = useLogout();
    const [showCsvModal, setShowCsvModal] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [orderData, setOrderData] = useState([]);
    const [csvId, setCsvId] = useState('');
    const [selectedOrder, setSelectedOrder] = useState({});
    const [openModel, setOpenModel] = useState(false);
    const [StageNames, setStageNames] = useState({});
    const [postProdColumnsToRemove, setPostProdColumnsToRemove] = useState([]);
    const [downloadSkuId, setDownloadSkuId] = useState('');
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [orderSearch, setOrderSearch] = useState('');
    const [appliedOrderSearch, setAppliedOrderSearch] = useState('');
    const [orderTableData, setOrderTableData] = useState([]);
    const [showPiModal, setShowPiModal] = useState(false);
    const [piRequestData, setPiRequestData] = useState([]);
    const [getValueOfRequest, setGetValueOfRequest] = useState([]);
    const [orderId, setOrderId] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [batchNo, setBatchNo] = useState('');
    const [rejectValue, setRejectValue] = useState('');
    const [api, contextHolder] = notification.useNotification();
    const [togglePostProduction, setTogglePostProduction] = useState(false);
    const [isCSAOrders, setIsCSAOrders] = useState(false);
    const [openDownloadPiiModal, setOpenDownloadPiiModal] = useState({
        showModal: false,
    });
    const [csvName, setCsvName] = useState('');
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [openStyleColorLibraryModal, setOpenStyleColorLibraryModal] = useState(false);
    const [selectedOrderForLibrary, setSelectedOrderForLibrary] = useState(null);
    const [isCSAModalOpen, setIsCSAModalOpen] = useState(false);
    const [csaConfirmText, setCsaConfirmText] = useState('');
    const [pendingCSAOrder, setPendingCSAOrder] = useState({ orderId: null, isClientSupportingArticle: false, orderName: null });
    const [isSyncGTOMModalOpen, setIsSyncGTOMModalOpen] = useState(false);
    const [syncGTOMConfirmText, setSyncGTOMConfirmText] = useState('');
    const [pendingSyncGTOMOrder, setPendingSyncGTOMOrder] = useState({ orderId: null, orderName: null });
    const { dashboardRetainment: detailsContextForDashboard } = useContext(RetainmentContext);
    const [dashboardDetails, setDashboardDetails] = detailsContextForDashboard;
    const [csvType, setCsvType] = useState('');
    const { mutate: DownloadOutboundReport } = useDownloadOutboundReport(onOutboundDownload);
    const { mutate: handleSkipSkusForCC } = useIgnoreforCC(onIgnoreSuccess, onIgnoreFailure);

    function onIgnoreSuccess(resp) {
        api.success({
            message: resp?.data?.message || 'Successfully ignored SKU for CC',
        });
    }

    function onIgnoreFailure(err) {
        console.log(err);
        api.error({
            message: err?.response?.data?.message,
        });
        if (err?.response?.status === 401) logout();
    }

    useEffect(() => {
        if (dashboardDetails?.persistedFilters?.length > 0) {
            setCompanyCodeText(dashboardDetails?.persistedFilters[0]);
        }
    }, []);

    useEffect(() => {
        if (!companyCodeText) {
            setAppliedOrderSearch('');
            return undefined;
        }
        const timer = setTimeout(() => {
            const next = orderSearch.trim();
            setAppliedOrderSearch(prev => {
                if (prev !== next) setPageNumber(1);
                return next;
            });
        }, 400);
        return () => clearTimeout(timer);
    }, [orderSearch, companyCodeText]);

    const onDownloadPiiSuccess = resp => {
        api.success({
            message: resp?.data?.message,
        });
        setOpenDownloadPiiModal({ showModal: false, orderId: null });
    };
    const onDownloadPiiError = err => {
        api.error({
            message: err?.response?.data?.message,
        });
        if (err?.response?.status === 401) logout();
    };
    const { mutate: downloadPII, isLoading: downloadPIILoading } = useDownloadPII(onDownloadPiiSuccess, onDownloadPiiError);
    const { mutate: downloadCC, isLoading: downloadCCLoading } = useDownloadCC(onDownloadPiiSuccess, onDownloadPiiError);
    const { mutate: generateInbound, isLoading: inboundReportLoading } = useGenerateInboundReport(onDownloadPiiSuccess, onDownloadPiiError);

    const onSuccessOrder = data => {
        setOrderTableData(data?.data);
    };
    const OrderError = err => {
        if (err?.response?.status === 401) logout();
    };
    const {
        refetch: fetchOrders,
        data: orders,
        isFetching,
        isError,
    } = useQuery(['listing', pageNumber, pageSize, companyCodeText, isCSAOrders, companyCodeText ? appliedOrderSearch : ''], fetchAllOrders, {
        refetchOnWindowFocus: true,
        onSuccess: onSuccessOrder,
        onError: OrderError,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });

    const {
        refetch: refetchNotifications,
        data: notifications,
        isFetching: isNotificationsFetching,
    } = useQuery(['Notifications', orderId], fetchNotificationsForOrder, {
        refetchOnWindowFocus: true,
    });

    const onSuccessRequestApprove = data => {
        api.success({
            message: 'Request successful',
        });
    };

    const onErrorRequestApprove = data => {
        api.error({
            message: data.response.data.message,
        });
    };

    const onErrorRequestReject = data => {
        api.error({
            message: data.response.data.message,
        });
    };

    const onSuccessRequestReject = data => {
        api.success({
            message: 'Request reject successful',
        });
    };

    const { refetch: requestApproved } = useQuery(['approve', getValueOfRequest[1], getValueOfRequest[0]], piRequestSuccess, {
        enabled: false,
        onSuccess: onSuccessRequestApprove,
        onError: onErrorRequestApprove,
    });
    const { refetch: requestReject } = useQuery(['reject', getValueOfRequest[1], getValueOfRequest[0]], piRequestReject, {
        enabled: false,
        onSuccess: onSuccessRequestReject,
        onError: onErrorRequestReject,
    });

    useEffect(() => {
        setOrderData(orders);
        orders?.data?.StageNames && setStageNames(orders?.data?.StageNames);
        orders?.data?.PostProductionStages && setPostProdColumnsToRemove(orders?.data?.PostProductionStages);
    }, [orders]);

    const closeModal = () => {
        setOpenModel(false);
    };
    const closePiModal = () => {
        setShowPiModal(false);
    };

    const navigate = useNavigate();

    const getCsv = () => fetchAllCSvOrders(csvId);
    const getCsvOutbound = () => fetchAllCSvOutboundOrders(csvId);

    const downloadId = () => downloadSku(downloadSkuId);

    const { data, refetch } = useQuery(['csvOrders', csvId], getCsv, {
        enabled: false,
    });
    const { data: outBountData, refetch: outBoundRefetch } = useQuery(['csvOrdersOutbound', csvId], getCsvOutbound, {
        enabled: false,
    });
    const { data: companyCodeList } = useListingCompanies();

    const onSuccessCsvData = data => {
        var blob = new Blob([data.data], {
            type: data.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let filename = data.headers['content-disposition'].split('filename=')[1].split('.')[0];
        link.setAttribute('download', `${filename}.xlsx`);
        document.body.appendChild(link);
        link.click();
    };

    function onOutboundDownload(resp) {
        onSuccessCsvData(resp);
    }

    const { refetch: downloadSkuData } = useQuery(['skuId', downloadSkuId], downloadId, {
        enabled: false,
        onSuccess: onSuccessCsvData,
    });

    useEffect(() => {
        fetchOrders();
    }, [companyCodeText, pageNumber, pageSize]);

    useEffect(() => {
        fetchOrders();
        if (csvId && csvType == 'inbound') {
            refetch();
        } else if (csvId && csvType == 'outbound') {
            outBoundRefetch();
        }
    }, [csvId, refetch, csvType]);

    useEffect(() => {
        if (rejectValue === 'approved') {
            requestApproved();
        }

        if (rejectValue === 'rejectApprove') {
            requestReject();
        }

        if (downloadSkuId) {
            downloadSkuData();
        }
    }, [getValueOfRequest, rejectValue, downloadSkuId]);

    const goToBookingDetails = id => {
        navigate('/bookingDetails', {
            state: {
                orderId: id,
            },
        });
    };

    const showManageCsvDetails = (id, type, name) => {
        console.log(id, type, name, 'showManageCsvDetails');
        setShowCsvModal(true);
        setCsvId(id);
        setCsvType(type);
        setCsvName(name);
    };

    const downloadSKu = (id, companyCode, batchNo) => {
        setDownloadSkuId(id);
        setCompanyCode(companyCode);
        setBatchNo(batchNo);
    };

    const showPiRequestModal = (data, orderId) => {
        setShowPiModal(true);
        setPiRequestData({
            data: data,
            orderId: orderId,
        });
    };

    const getTrackNumberAndId = value => {
        setGetValueOfRequest(value);
    };

    const getRejectValue = value => {
        setRejectValue(value);
    };

    const handleStyleColorLibrary = order => {
        setSelectedOrderForLibrary(order);
        setOpenStyleColorLibraryModal(true);
    };

    const onCloseStyleColorLibraryModal = () => {
        setOpenStyleColorLibraryModal(false);
        setSelectedOrderForLibrary(null);
    };
    const onSuccessMarkOrderCSA = (resp) => {
        message.success(
            resp?.data?.message || 'Order marked successfully',
        );
        fetchOrders();
    };
    const onErrorMarkOrderCSA = (err) => {
        message.error(
            err?.response?.data?.message || 'Failed to mark order as CSA',
        );
    };
    const { mutate: markOrderCSA } = useMarkOrderCSA(onSuccessMarkOrderCSA, onErrorMarkOrderCSA);

    const handleMarkOrderCSA = (orderId, isClientSupportingArticle) => {
        const payload = {
            orderId: orderId,
            isClientSupportingArticle: isClientSupportingArticle,
        };
        markOrderCSA(payload);
    };

    const openCSAModal = (orderId, isClientSupportingArticle, orderName) => {
        setPendingCSAOrder({ orderId, isClientSupportingArticle, orderName: orderName ?? null });
        setCsaConfirmText('');
        setIsCSAModalOpen(true);
    };

    const handleConfirmCSAModal = () => {
        if (csaConfirmText !== 'I confirm') {
            return;
        }
        if (pendingCSAOrder.orderId) {
            handleMarkOrderCSA(pendingCSAOrder.orderId, pendingCSAOrder.isClientSupportingArticle);
        }
        setIsCSAModalOpen(false);
        setCsaConfirmText('');
        setPendingCSAOrder({ orderId: null, isClientSupportingArticle: false, orderName: null });
    };

    const handleCancelCSAModal = () => {
        setIsCSAModalOpen(false);
        setCsaConfirmText('');
        setPendingCSAOrder({ orderId: null, isClientSupportingArticle: false, orderName: null });
    };

    const onSuccessSyncGTOM = (resp) => {
        message.success(
            resp?.data?.message || 'Data synced to GTOM successfully',
        );
        fetchOrders();
    };
    const onErrorSyncGTOM = (err) => {
        message.error(
            err?.response?.data?.message || 'Failed to sync data to GTOM',
        );
    };
    const { mutate: syncDataToGTOM } = useSyncDataToAIStyling(onSuccessSyncGTOM, onErrorSyncGTOM);

    const handleSyncDataToGTOM = (orderId) => {
        syncDataToGTOM({ orderId });
    };

    const openSyncGTOMModal = (orderId, orderName) => {
        setPendingSyncGTOMOrder({ orderId, orderName: orderName ?? null });
        setSyncGTOMConfirmText('');
        setIsSyncGTOMModalOpen(true);
    };

    const handleConfirmSyncGTOMModal = () => {
        if (syncGTOMConfirmText !== 'I confirm') {
            return;
        }
        if (pendingSyncGTOMOrder.orderId) {
            handleSyncDataToGTOM(pendingSyncGTOMOrder.orderId);
        }
        setIsSyncGTOMModalOpen(false);
        setSyncGTOMConfirmText('');
        setPendingSyncGTOMOrder({ orderId: null, orderName: null });
    };

    const handleCancelSyncGTOMModal = () => {
        setIsSyncGTOMModalOpen(false);
        setSyncGTOMConfirmText('');
        setPendingSyncGTOMOrder({ orderId: null, orderName: null });
    };

    const Content = ({ props }) => (
        <>
            <div className="py-1 content-item" onClick={() => goToBookingDetails(props._id)}>
                <Text className="popover_links"> Assign Studio</Text>
            </div>
            <div
                className="py-1 content-item"
                onClick={() => {
                    console.log('OnCLICK');
                    showManageCsvDetails(props._id, 'inbound', props.name);
                }}
            >
                {/* <FileExcelOutlined  /> */}
                <Text className="popover_links"> Manage Inbound CSV</Text>
            </div>
            <div className="py-1 content-item" onClick={() => showManageCsvDetails(props._id, 'outbound', props.name)}>
                {/* <FileExcelOutlined  /> */}
                <Text className="popover_links"> Manage Outbound CSV</Text>
            </div>
            <div className="py-1 content-item">
                <Link id="ddLink" className="py-1 content-item dd_link popover_links" href={props.ddURL} target="_blank" block>
                    View Deliverable Deck
                </Link>
            </div>
            <div
                className="py-1 content-item"
                onClick={() => {
                    setOpenModel(true);
                    setSelectedOrder(props);
                }}
            >
                <Text className="popover_links"> View Shooting Guidelines</Text>
            </div>
            <div className="py-1 content-item" onClick={() => goToBookingDetails(props._id)}>
                <Text className="popover_links"> Order Details</Text>
            </div>
            <div className="py-1 content-item" onClick={() => downloadSKu(props._id, props.companyCode, props.batchNo)}>
                <Text className="popover_links"> Download XLSX</Text>
            </div>
            <div
                className="py-1 content-item"
                onClick={() => {
                    setOpenDownloadPiiModal({
                        showModal: true,
                        orderId: props?._id,
                        batchName: props.name,
                        type: 'pii',
                    });
                }}
            >
                <Text className="popover_links"> Download PII Images</Text>
            </div>
            <div
                className="py-1 content-item"
                onClick={() => {
                    setOpenDownloadPiiModal({
                        showModal: true,
                        orderId: props?._id,
                        batchName: props.name,
                        type: 'cc',
                    });
                }}
            >
                <Text className="popover_links"> Download CC Images</Text>
            </div>
            <div
                className="py-1 content-item"
                onClick={() => {
                    setOpenDownloadPiiModal({
                        showModal: true,
                        orderId: props?._id,
                        batchName: props.name,
                        type: 'inbound',
                    });
                }}
            >
                <Text className="popover_links"> Generate Inbound Report</Text>
            </div>
            <div className="py-1 content-item" onClick={() => DownloadOutboundReport(props?._id)}>
                <Text className="popover_links"> Download Outbound Report</Text>
            </div>
            <div className="py-1 content-item" onClick={() => handleSkipSkusForCC(props?._id)}>
                <Text className="popover_links"> Ignore Skus for CC</Text>
            </div>
            <div className="py-1 content-item" onClick={() => handleStyleColorLibrary(props)}>
                <Text className="popover_links"> Style and Color Library</Text>
            </div>
            {props?.piiReopenRequests?.some(item => !!item.requestOpen) && (
                <div className="py-1 content-item" onClick={() => showPiRequestModal(props?.piiReopenRequests, props?._id)}>
                    <Text className="popover_links">PII Re-open Requests</Text>
                </div>
            )}
            {
                !props?.isClientSupportingArticle ? (
                    <div className="py-1 content-item" onClick={() => openCSAModal(props?._id, true, props?.name)}>
                        <Text className="popover_links"> Mark as CSA</Text>
                    </div>
                ) : (
                    <div className="py-1 content-item" onClick={() => openCSAModal(props?._id, false, props?.name)}>
                        <Text className="popover_links"> Unmark as CSA</Text>
                    </div>
                )
            }
            <div className="py-1 content-item" onClick={() => openSyncGTOMModal(props?._id, props?.name)}>
                <Text className="popover_links"> Sync Data To GTOM</Text>
            </div>
        </>
    );

    const getArrowSign = (value, remark) => {
        return value > 0 ? (
            <ArrowUpOutlined
                style={{
                    color: remark === 'pending' ? '#F29339' : '#52c41a',
                    margin: 0,
                    padding: 0,
                }}
            />
        ) : (
            <ArrowDownOutlined
                style={{
                    color: remark === 'pending' ? '#52c41a' : '#F29339',
                    margin: 0,
                    padding: 0,
                }}
            />
        );
    };

    const getIncrementDecrementColor = (value, remark) => {
        return value > 0 ? (remark === 'pending' ? '#F29339' : '#52c41a') : remark === 'pending' ? '#52c41a' : '#F29339';
    };

    const getIncrementDecrement = (value, remark) => {
        if (value !== 0) {
            return (
                <span
                    style={{
                        color: getIncrementDecrementColor(value, remark),
                        margin: 0,
                        padding: 0,
                    }}
                >
                    {`(`}
                    {getArrowSign(value, remark)}
                    {Math.abs(value)}
                    {`)`}
                </span>
            );
        }

        return null;
    };

    const getTimeComparision = timeStamp => {
        return `${new Date(timeStamp).toLocaleTimeString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        })} `;
    };

    const stageStatusView = (status, timeStamp, completedLabel = 'completed') => {
        const title = (
            <>
                {status?.pending > 0 && (
                    <div>
                        <span style={{ color: '#F29339', fontSize: '20px', position: 'relative' }}>
                            {`😟 pending: ${status?.pending} `}
                            {getIncrementDecrement(status?.pendingDiff, 'pending')}
                        </span>
                        <br />
                    </div>
                )}
                {status?.completed > 0 && (
                    <div>
                        {' '}
                        <span style={{ color: '#52c41a', fontSize: '20px' }}>
                            {`🤩 ${completedLabel}: ${status?.completed} `}
                            {getIncrementDecrement(status?.completedDiff, 'complete')}
                        </span>
                        <br />
                    </div>
                )}

                <div>
                    <span style={{ color: '#3c8cd2', fontSize: '20px' }}>{`🙂 total: ${status?.completed + status?.pending}`}</span>
                </div>
                {timeStamp && (
                    <div>
                        <span style={{ color: '#FCE09B', fontSize: '14px', paddingLeft: '4px' }}>
                            <ControlOutlined style={{ fontSize: '16px' }} />
                            {'  '}
                            {`${getTimeComparision(timeStamp)}`}
                        </span>
                    </div>
                )}
            </>
        );
        if (status.pending == 0 && status.completed == 0) {
            return <></>;
        } else if (status.pending > 0 && status.completed == 0) {
            return (
                <>
                    <Tooltip title={title} placement="topRight">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <span style={{ color: '#F29339', fontSize: '16px' }}>
                                <ClockCircleOutlined />
                                {' ' + status?.pending}
                            </span>
                        </div>
                    </Tooltip>
                </>
            );
        } else if (status.pending == 0 && status.completed > 0) {
            return (
                <Tooltip title={title} placement="topRight">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '32px' }} />
                    </div>
                </Tooltip>
            );
        } else if (status.pending > 0 && status.completed > 0) {
            return (
                <>
                    <Tooltip title={title} placement="topRight">
                        <span style={{ color: '#F29339', fontSize: '16px' }}>
                            <ClockCircleOutlined />
                            {' ' + status?.pending}
                        </span>
                        <br />
                        <span style={{ color: 'darkgreen', fontSize: '16px' }}>
                            <CheckCircleOutlined />
                            {' ' + status?.completed}
                        </span>
                    </Tooltip>
                </>
            );
        }
    };

    const csvColumn = {
        title: 'CSV',
        dataIndex: 'csvStatus',
        key: 'CSV',
        align: 'center',
        render: (_, record) => {
            const timeStamp = record?.orderSnapshotTimestamp || '';
            return <span>{record?.csvStatus && stageStatusView(record.csvStatus, timeStamp, 'consumed')}</span>;
        },
    };

    const stageColumns = [];
    Object.keys(StageNames).forEach(stage => {
        stageColumns.push({
            title: StageNames[stage],
            dataIndex: 'stage',
            key: stage,
            align: 'center',
            render: (_, record) => {
                const status = record?.status?.find(d => d.stage === stage);
                const timeStamp = record?.orderSnapshotTimestamp || '';
                return <span>{status && stageStatusView(status, timeStamp)}</span>;
            },
        });
    });

    const column = [
        {
            title: 'Batch No',
            dataIndex: 'batchNo',
            key: 'batchNo',
        },
        {
            title: 'Company Code',
            dataIndex: 'companyCode',
            key: 'code',
            render: (_, record) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            flexDirection: 'row',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: stc(record?.companyCode),
                                width: '10px',
                                height: '50px',
                                // border: "1px solid #000",
                                marginRight: '15px',
                            }}
                        ></div>
                        <span>
                            <b>{record?.companyCode}</b>
                        </span>
                    </div>
                );
            },
        },
        {
            title: 'Order Name',
            dataIndex: 'name',
            key: 'name',
            render: (_, record) => {
                return (
                    <div>
                        {!!record?.notificationCount && record?.notificationCount > 0 && (
                            <Button
                                danger
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '5px',
                                }}
                                onClick={() => {
                                    console.log(record?._id);
                                    setOrderId(record?._id);
                                    refetchNotifications();
                                    setShowNotificationModal(true);
                                }}
                            >
                                <p>
                                    <WarningOutlined />
                                    {record?.notificationCount}
                                </p>
                            </Button>
                        )}
                        {record?.name && (
                            <b>
                                <span>{record.name}</span>
                                {record?.isClientSupportingArticle && (
                                    <Tooltip title="Client Supporting Article">
                                        <Tag color="blue" style={{ marginLeft: 8 }}>CSA</Tag>
                                    </Tooltip>
                                )}
                            </b>
                        )}
                        <br />
                        {record?.createdBy?.name && (
                            <span
                                style={{
                                    fontWeight: '100',
                                    fontSize: '11px',
                                }}
                            >
                                Created by: {record?.createdBy?.name}
                            </span>
                        )}
                        <br />
                        {record?.createdAt && (
                            <i>
                                <span
                                    style={{
                                        fontWeight: '100',
                                        fontSize: '11px',
                                    }}
                                >
                                    {record.createdAt &&
                                        new Date(record.createdAt).toLocaleDateString('en-US', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                        })}
                                </span>
                            </i>
                        )}
                        <br />
                        {record?.studios?.map((studio, i) => {
                            return (
                                <span
                                    key={i}
                                    style={{
                                        fontWeight: '100',
                                        fontSize: '11px',
                                    }}
                                >
                                    {`${studio.studioName}(${studio.studioCode})`}
                                </span>
                            );
                        })}
                    </div>
                );
            },
        },
        csvColumn,
        ...stageColumns,
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: '50px',
            render: (_, record) => {
                const showPiResult = record?.piiReopenRequests?.some(item => !!item.requestOpen);
                return (
                    <div className="icon_legend">
                        <Popover placement="left" content={<Content props={record} />}>
                            <Button size="small" type="default">
                                <MoreOutlined />
                            </Button>
                        </Popover>
                        {showPiResult && <Badge status="warning" />}
                    </div>
                );
            },
        },
    ];

    let columnToShow = [...column];

    if (!togglePostProduction) {
        let columnArray = [...columnToShow];
        columnToShow = columnArray.filter(item => postProdColumnsToRemove.indexOf(item?.key) < 0);
    } else {
        columnToShow = [...column];
    }

    const spinIcon = (
        <div className="spin-center">
            <Spin className="spin_loader" size="large" />{' '}
        </div>
    );

    const oncompanyCodeChange = value => {
        setCompanyCodeText(value);
        setPageNumber(1);
        if (!value) {
            setOrderSearch('');
            setAppliedOrderSearch('');
        }
        setDashboardDetails(prev => ({
            ...prev,
            persistedFilters: [value],
        }));
    };

    const resetFilter = () => {
        setCompanyCodeText('');
        setOrderSearch('');
        setAppliedOrderSearch('');
        setPageNumber(1);
        setIsCSAOrders(false);
        setDashboardDetails(prev => ({
            ...prev,
            persistedFilters: [],
        }));
    };

    const handlePostProductionChange = value => {
        setTogglePostProduction(value);
    };

    const handleCSAOrdersChange = value => {
        setIsCSAOrders(value);
        setPageNumber(1);
    };

    return (
        <>
            {contextHolder}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}
            >
                <span
                    style={{
                        fontSize: '13px',
                        fontWeight: '600',
                    }}
                >
                    Filter by company code
                </span>
                <Select
                    showSearch
                    placeholder="Select company code"
                    onChange={text => oncompanyCodeChange(text)}
                    className="filter_dropdown"
                    value={companyCodeText}
                >
                    <Select.Option key="none" value={''}>
                        All
                    </Select.Option>
                    {companyCodeList?.map(el => {
                        return (
                            <Select.Option key={el._id} value={el.code}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: stc(el.code),
                                            width: '5px',
                                            height: '15px',
                                            marginRight: '5px',
                                        }}
                                    ></div>
                                    <span>{el.code}</span>
                                </div>
                            </Select.Option>
                        );
                    })}
                </Select>
                <Input
                    allowClear
                    style={{ width: 220, marginLeft: 8 }}
                    value={orderSearch}
                    disabled={!companyCodeText}
                    placeholder={companyCodeText ? 'Partial order name' : 'Select a client to search'}
                    onChange={event => setOrderSearch(event.target.value)}
                />
                <Button onClick={resetFilter}>Reset Filters</Button>
            </div>
            <hr
                style={{
                    width: '100%',
                    margin: '10px 0 8px 0',
                    color: '#e8e8e8',
                }}
            />
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '16px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                        style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            padding: '0 4px',
                        }}
                    >
                        CSA Orders
                    </span>
                    <Switch
                        onChange={handleCSAOrdersChange}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        autoFocus={false}
                        checked={isCSAOrders}
                        size="small"
                    ></Switch>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                        style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            padding: '0 4px',
                        }}
                    >
                        Post Production
                    </span>
                    <Switch
                        onChange={value => {
                            handlePostProductionChange(value);
                        }}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        autoFocus={false}
                        checked={togglePostProduction}
                        size="small"
                    ></Switch>
                </div>
            </div>
            <div
                style={{
                    height: 'calc(100% - 155px)',
                    marginTop: '35px',
                    overflow: 'auto',
                }}
            >
                <CommonTable
                    data={orderTableData?.data}
                    columns={columnToShow}
                    loading={{
                        spinning: isFetching,
                        indicator: spinIcon,
                    }}
                    bordered
                    size="small"
                />
            </div>
            <div
                style={{
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Pagination
                    current={pageNumber}
                    onChange={page => {
                        setPageNumber(page);
                    }}
                    pageSizeOptions={['15', '30', '50']}
                    total={orderTableData?.totalCount}
                    pageSize={pageSize}
                    defaultPageSize={pageSize}
                    showSizeChanger
                    onShowSizeChange={(current, size) => {
                        setPageSize(size);
                        setPageNumber(1);
                    }}
                />
            </div>
            <PlusIconActionButton onClick={() => navigate('/newOrder')} title={'Create Order'} />

            {showCsvModal && (
                <DynamicModal
                    open={true}
                    width={1000}
                    close={() => setShowCsvModal(false)}
                    title={csvName}
                    component={
                        <ManageCsv
                            csvId={csvId}
                            csvOrder={(csvType == 'outbound' ? outBountData?.data?.outboundCsvs : data?.data) ?? []}
                            setShowCsvModal={setShowCsvModal}
                            getCsv={getCsv}
                            setCsvId={setCsvId}
                            csvType={csvType}
                        />
                    }
                />
            )}
            {showPiModal && (
                <DynamicModal
                    open={showPiModal}
                    close={closePiModal}
                    closable
                    title={'PII Re-open Request Status'}
                    component={piRequestData?.data?.map((item, index) => (
                        <PiRequestStatus
                            data={{ ...item, orderId: piRequestData?.orderId }}
                            key={index}
                            getTrackNumberAndId={getTrackNumberAndId}
                            getRejectValue={getRejectValue}
                            close={closePiModal}
                        />
                    ))}
                />
            )}
            {openDownloadPiiModal.showModal && (
                <DynamicModal
                    open={openDownloadPiiModal}
                    close={() => setOpenDownloadPiiModal({ showModal: false })}
                    closable
                    title={openDownloadPiiModal?.batchName}
                    component={
                        <DownloadPiiModal
                            downloadPII={downloadPII}
                            orderId={openDownloadPiiModal?.orderId}
                            type={openDownloadPiiModal.type}
                            downloadCC={downloadCC}
                            generateInbound={generateInbound}
                            loading={inboundReportLoading || downloadCCLoading || downloadPIILoading}
                        />
                    }
                />
            )}
            {showNotificationModal && (
                <DynamicModal
                    open={showNotificationModal}
                    close={() => setShowNotificationModal(false)}
                    closable
                    title={`FMS Rejections : ${notifications?.data?.length}`}
                    component={
                        !isNotificationsFetching && (
                            <NotificationModal
                                notifications={notifications}
                                refetch={() => {
                                    refetchNotifications();
                                    fetchOrders();
                                }}
                                orderId={orderId}
                            />
                        )
                    }
                    width="60%"
                />
            )}
            {openStyleColorLibraryModal && (
                <DynamicModal
                    open={true}
                    width={800}
                    title="Style and Color Library"
                    closable={true}
                    close={onCloseStyleColorLibraryModal}
                    component={
                        <StyleColorLibraryModal
                            record={selectedOrderForLibrary}
                            orderId={selectedOrderForLibrary?._id}
                            onClose={onCloseStyleColorLibraryModal}
                        />
                    }
                />
            )}
            <Modal
                open={isCSAModalOpen}
                title={pendingCSAOrder.isClientSupportingArticle ? 'Confirm Mark as CSA' : 'Confirm Unmark as CSA'}
                onOk={handleConfirmCSAModal}
                onCancel={handleCancelCSAModal}
                okText="Confirm"
                cancelText="Cancel"
                okButtonProps={{ disabled: csaConfirmText !== 'I confirm' }}
            >
                {pendingCSAOrder.orderName ? (
                    <p><strong>Order:</strong> {pendingCSAOrder.orderName}</p>
                ) : (
                    <p><strong>Order:</strong> —</p>
                )}
                <p>
                    {pendingCSAOrder.isClientSupportingArticle
                        ? 'Are you sure you want to mark this order as Client Supporting Article (CSA)?'
                        : 'Are you sure you want to unmark this order as Client Supporting Article (CSA)?'}
                </p>
                <p>
                    Please type <b>I confirm</b> to proceed.
                </p>
                <Input
                    value={csaConfirmText}
                    onChange={e => setCsaConfirmText(e.target.value)}
                    placeholder="Type 'I confirm' to proceed"
                />
            </Modal>
            <Modal
                open={isSyncGTOMModalOpen}
                title="Confirm Sync Data To GTOM"
                onOk={handleConfirmSyncGTOMModal}
                onCancel={handleCancelSyncGTOMModal}
                okText="Confirm"
                cancelText="Cancel"
                okButtonProps={{ disabled: syncGTOMConfirmText !== 'I confirm' }}
            >
                {pendingSyncGTOMOrder.orderName ? (
                    <p><strong>Order:</strong> {pendingSyncGTOMOrder.orderName}</p>
                ) : (
                    <p><strong>Order:</strong> —</p>
                )}
                <p>
                    Are you sure you want to sync this order's data to GTOM?
                </p>
                <p>
                    Please type <b>I confirm</b> to proceed.
                </p>
                <Input
                    value={syncGTOMConfirmText}
                    onChange={e => setSyncGTOMConfirmText(e.target.value)}
                    placeholder="Type 'I confirm' to proceed"
                />
            </Modal>
            <DynamicModal
                open={openModel}
                close={closeModal}
                closable
                title="Shooting Guidelines Links"
                component={
                    <List
                        itemLayout="horizontal"
                        dataSource={selectedOrder.sglURLs}
                        renderItem={(link, i) => (
                            <List.Item>
                                <List.Item.Meta
                                    title={`open link ${i + 1}:`}
                                    description={
                                        <a href={link} target="_blank" rel="noreferrer">
                                            {link}
                                        </a>
                                    }
                                />
                                <CopyOutlined className="copy_link" onClick={() => navigator.clipboard.writeText(link)} />
                            </List.Item>
                        )}
                    />
                }
            />
        </>
    );
};

export default AllOrders;
